export default __webpack_public_path__ + "static/media/walk-to-school.3b48040e.jpg";